import ComingSoon from "../../../components/ui/ComingSoon/ComingSoon";
import PageHeader from "../../pageheader/components/PageHeader"

const SettingsPage: React.FC = () => {
    return (
        <>
            <PageHeader name="Settings"></PageHeader>
            <ComingSoon />
        </>
    )
}

export default SettingsPage;